var _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHomeLine(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 626,
    height: 692,
    viewBox: "0 0 626 692",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 250.913,
    cy: -171.606,
    r: 373.894,
    stroke: "#FF0000",
    strokeOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 152.394,
    cy: 316.651,
    r: 373.894,
    stroke: "#FFA2A2",
    strokeOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeLine);
export default __webpack_public_path__ + "static/media/home-line.222b31a685ff689907cf2d53ec83b4cf.svg";
export { ForwardRef as ReactComponent };